import React from "react";
import { useFormik } from "formik";
import { Modal, Button, Form } from "react-bootstrap";
import { MultiSelect } from "react-multi-select-component";
import countries from "../../JSON/isoCode.json";

const EditMasterFormWithCountryCode = ({
  formName,
  editMasterDataName,
  editMasterData,
  showEditForm,
  setShowEditForm,
}) => {
  const validate = (values) => {
    const errors = {};
    if (!values.name ) {
      errors.name = `Please Enter ${formName} Name.`;
    } else if (!values.name.trim()) {
      errors.name = `The ${formName} Name Cannot Be Blank.`;
    } else if (values?.isoCode?.length === 0) {
      errors.isoCode = `Please Select Country Name.`;
    }
    return errors;
  };
  const isoCodeInfo = editMasterDataName?.isoCode.length ? editMasterDataName?.isoCode?.map(({ label, value }) => ({ label, value })) : []
  const handleHide = () => { 
    setShowEditForm(false);
    formik.resetForm();
  }
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editMasterDataName?.name,
      isoCode: isoCodeInfo,
    },
    validate,
    onSubmit: (values) => {
      editMasterData({
        statusId: editMasterDataName?.statusId,
        name: values?.name,
        isoCode: values?.isoCode,
      });
      handleHide();
    },
  });
  return (
    <Modal show={showEditForm} onHide={() => handleHide()} centered>
      <Modal.Header className="dialog-header" closeButton>
        <Modal.Title>Edit {formName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={formik.handleSubmit}>
          <Form.Group controlId="formName">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              isInvalid={formik.touched.name && !!formik.errors.name}
            />
            <Form.Control.Feedback type="invalid">
              {formik.touched.name && formik.errors.name}
            </Form.Control.Feedback>
          </Form.Group>
          <br />
          <Form.Group controlId="formCountry">
            <Form.Label>{formName} Country</Form.Label>
            <div className="card flex justify-content-center">
              <MultiSelect
                value={formik?.values?.isoCode}
                options={countries}
                onChange={(selected) => formik.setFieldValue("isoCode", selected) }
                name="isoCode"
                labelledBy="Select Countries"
                className="w-full md:w-20rem"
              />
            </div>
            {formik.touched.isoCode && formik.errors.isoCode ? (
              <div
                className="invalid-feedback d-block"
                style={{ color: "red" }}
              >
                {formik.errors.isoCode}
              </div>
            ) : null}
          </Form.Group>
          <br />
          <Modal.Footer>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditMasterFormWithCountryCode;
